import { render, staticRenderFns } from "./MentoringRecordModal.vue?vue&type=template&id=6ab4bfae&scoped=true"
import script from "./MentoringRecordModal.vue?vue&type=script&lang=js"
export * from "./MentoringRecordModal.vue?vue&type=script&lang=js"
import style0 from "./MentoringRecordModal.vue?vue&type=style&index=0&id=6ab4bfae&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab4bfae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab4bfae')) {
      api.createRecord('6ab4bfae', component.options)
    } else {
      api.reload('6ab4bfae', component.options)
    }
    module.hot.accept("./MentoringRecordModal.vue?vue&type=template&id=6ab4bfae&scoped=true", function () {
      api.rerender('6ab4bfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/MentoringRecordModal.vue"
export default component.exports